// Single source of truth for the satisFINDER® Code of Conduct &
// Confidentiality Agreement. Shared by the signup acceptance modal
// (/satisfinder/signup) and the read-only profile viewer
// (Profile → Terms & privacy) so both stay consistent. Do not fork this
// wording — edit here and both surfaces update.
export const SATISFINDER_AGREEMENT = {
  eyebrow: 'Confidentiality & Code of Conduct',
  title: 'satisFINDER® Code of Conduct & Confidentiality Agreement',
  signupIntro:
    'Before joining as a satisFINDER®, please confirm that you understand and agree to our Code of Conduct.',
  summary:
    'satisFINDERS® are trusted to provide honest feedback, protect confidential project information, follow instructions, and act professionally.',
  commitmentsHeading: 'By continuing, you agree that you will:',
  commitments: [
    'Keep all FIND, survey, project, client, and guideline information confidential.',
    'Complete accepted FINDs honestly and professionally.',
    'Not accept FINDs where you, your family, or close friends have a conflict of interest.',
    'Not reveal yourself as a satisFINDER® unless specifically instructed.',
    'Not contact clients directly without satisFIND® approval.',
    'Submit reports on time or release the FIND if you cannot complete it.',
    'Communicate respectfully with the satisFIND® team.',
  ],
  acknowledgements: [
    'I will submit honest answers in my own words, based on my own experience.',
    'I agree to follow the satisFINDER Code of Conduct and Confidentiality Agreement. I understand that breaches may result in suspension or permanent removal from the satisFINDER community.',
  ],
};
